import Cookies from "js-cookie"

const signinedToken = "appToken"

let currentUser

export const imageCdnUrl = (image, { m = "fill", w, h = "" }) =>
  `https://image.gcores.com/${image}?x-oss-process=image/resize,limit_1,m_${m},w_${w}${
    h ? `,h_${h}` : ""
  }/quality,q_90`

export const postAppMsg = (type, data) => {
  if (window.ReactNativeWebView) {
    const postData = JSON.stringify({
      type,
      data,
    })
    window.ReactNativeWebView.postMessage(postData)
  }
}

export const platformCheck = (
  taskInApp,
  taskInWeb,
  { needAdvanced = true, onlyInApp = false } = {}
) => {
  if (window.ReactNativeWebView) {
    if (!needAdvanced || window.GCORES_APP_BUILD_NUMBER) {
      taskInApp()
      return
    }
    alert("此功能仅在最新版 App 提供，请更新。")
    return
  }
  if (onlyInApp) {
    if (
      window.confirm(
        "此功能仅在 机核 移动端提供，请下载 机核APP 使用，是否前往下载？"
      )
    ) {
      window.location.href = "https://www.gcores.com/app"
    }
    return
  }
  taskInWeb()
}
export const shareInApp = () => {
  platformCheck(
    () => {
      postAppMsg("share", window.getShareData?.())
    },
    () => {
      alert("请用机核 App 分享")
    }
  )
}

export const getCurrentUserToken = () => {
  return {
    token: window.appToken || Cookies.get("appToken"),
    userId: window.userID || Cookies.get("userID"),
  }
}

export const request = (path, options) => {
  return fetch(path, options).then((res) => (res ? res.json() : null))
}

export const requestGapi = (path, options = {}) => {
  const { token } = getCurrentUserToken()
  const requestOptions = {
    ...options,
    headers: {
      ...options.headers,
      ...(!(options.body instanceof FormData)
        ? {
            "Content-Type": "application/vnd.api+json",
          }
        : {}),
      ...(token
        ? {
            Authorization: `Token token=${token}`,
          }
        : {}),
    },
  }
  return request(`https://www.gcores.com/gapi/v1/${path}`, requestOptions)
}

export const requestCurrentUser = () => {
  if (currentUser !== undefined) {
    return Promise.resolve(currentUser)
  } else {
    const { userId, token } = getCurrentUserToken()
    if (!(userId && token)) {
      return Promise.resolve(null)
    }
    return requestGapi(`/users/${userId}`).then((res) => {
      return res?.data || null
    })
  }
}

export const requestGserver = (path, options) => {
  return request(`https://www.gcores.com/${path}`, options)
}

export const buildRels = (res) => {
  if (!res || !res.data) {
    return null
  }
  if (res.data instanceof Array) {
    return res.data.map((item) => ({
      ...item,
      rels: buildItemRels(item, res.included),
    }))
  }
  return {
    ...res.data,
    rels: buildItemRels(res.data, res.included),
  }
}

const buildItemRels = (item, included) => {
  if (!item) {
    return null
  }
  const rels = {}
  for (const relName of Object.keys(item.relationships)) {
    let rel = null
    const { data } = item.relationships[relName] || {}
    if (!data) {
      continue
    }
    const find = (item) => (item1) =>
      item.type === item1.type && item.id === item1.id
    if (data instanceof Array) {
      rel = data.map((item) => included.find(find(item)))
    } else {
      rel = included.find(find(data))
    }
    rels[relName] = rel
  }
  return rels
}
